import axios from 'axios';

export default axios.create({
  baseURL: `https://moduli-s3rv4atbwa-uw.a.run.app/`
  //baseURL: `https://test---moduli-s3rv4atbwa-uw.a.run.app/`
  //baseURL: 'http://localhost:4000'
});